import { camelToSnakeKeys, formatDateToString } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'

const mapGender = (data = {}) => {
  const { gender, genderIdentities } = data

  if (gender) return gender?.id

  if (!genderIdentities || genderIdentities?.id >= 3) return null

  return genderIdentities?.id
}

const mapName = (fullName) => {
  const [ name, ...last ] = fullName?.trim().split(' ') || [ '' ]

  return {
    name: name || '',
    lastName: last.join(' ') || ''
  }
}

export const mapEmployeeInput = ({ data } = {}) => camelToSnakeKeys({
  name: mapName(data?.name)?.name,
  lastName: mapName(data?.name)?.lastName,
})

export const mapPersonal = (data = {}) => ({
  ...data,
  name: data?.fullName,
  gender: mapGender(data),
  nationalities: data?.nationalities?.map(({ id }) => +id) || [],
  birthday: data?.birthDate,
  birthStateId: data?.birthState?.id,
  birthCityId: data?.birthCity?.id,
  genderIdentityId: data?.genderIdentities?.id,
  ethnicityId: data?.ethnicity?.id,
  maritalStatus: data?.maritalStatus?.id,
  maritalStatusId: data?.maritalStatus?.id,
})

export const mapPersonalInput = ({ schema, data } = {}) => ({
  ...camelToSnakeKeys({
    id: data?.id,
    motherName: data?.motherName,
    fatherName: data?.fatherName,
    birthStateId: data?.birthStateId,
    birthCityId: data?.birthCityId,
    birthDate: formatDateToString(data?.birthday),
    ethnicityId: data?.ethnicityId,
    maritalStatusId: data?.maritalStatusId,
    genderId: data?.gender,
    genderIdentityId: data?.genderIdentityId,
    socialName: data?.socialName,
  }),
  custom_fields: mapCustomFieldValues({
    data,
    schema,
    sectionId: PERSONAL_AREA.PERSONAL,
  })
})

export const mapNationalitiesInput = ({ data } = {}) => camelToSnakeKeys({
  nationalities: data?.nationalities?.map(({ id }) => +id) || []
})
